/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommerceoneTimePaymentsOneTimePayment from './TrustCommerceoneTimePaymentsOneTimePayment';

/**
 * The TrustCommerceOneTimePaymentsBody model module.
 * @module model/TrustCommerceOneTimePaymentsBody
 * @version v0.3
 */
export default class TrustCommerceOneTimePaymentsBody {
  /**
   * Constructs a new <code>TrustCommerceOneTimePaymentsBody</code>.
   * @alias module:model/TrustCommerceOneTimePaymentsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommerceOneTimePaymentsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommerceOneTimePaymentsBody} obj Optional instance to populate.
   * @return {module:model/TrustCommerceOneTimePaymentsBody} The populated <code>TrustCommerceOneTimePaymentsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommerceOneTimePaymentsBody();
      if (data.hasOwnProperty('one_time_payment'))
        obj.oneTimePayment = TrustCommerceoneTimePaymentsOneTimePayment.constructFromObject(data['one_time_payment']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommerceoneTimePaymentsOneTimePayment} oneTimePayment
 */
TrustCommerceOneTimePaymentsBody.prototype.oneTimePayment = undefined;

